import React, { useState, useEffect } from 'react';
import { Form, Alert, Spinner } from 'react-bootstrap';
import ModalGlobal from '../../../../../GlobalModules/Utility/Components/ModalGlobal';
import { closeBusinessRegister } from '../../../BusinessRegister/Controller/BusinessRegisterController';
import Utility from '../../../../../GlobalModules/Utility/Utility';

const CloseRegisterModal = ({ t, show, onHide, mode, registerData }) => {
    const [closingAmount, setClosingAmount] = useState('');
    const [creditCardSlips, setCreditCardSlips] = useState(0);
    const [cheques, setCheques] = useState(0);
    const [closeNote, setCloseNote] = useState('');
    const [formError, setFormError] = useState('');
    const [loading, setLoading] = useState(false);

    const expectedAmount = parseFloat(registerData?.orderAmount || 0);
    const variance = parseFloat((parseFloat(closingAmount || 0) - expectedAmount).toFixed(2));
    const hasVariance = Math.abs(variance) > 0.01;

    useEffect(() => {
        if (show && registerData) {
            setFormError('');
            setCloseNote('');
            // console.log("registerData====",registerData)
            // Active Business Register (registerData)
            setClosingAmount(registerData.orderAmount || registerData.opening_amount || '');
            setCreditCardSlips(registerData.credit_card_slips || 0);
            setCheques(registerData.cheques || 0);
        }
    }, [show, registerData]);

    const handleSubmit = async () => {
        // Joined sessions leave the register - no drawer count is taken
        if (mode === 'exit') {
            setLoading(true);
            const result = await closeBusinessRegister({
                closing_amount: 0,
                close_note: closeNote.trim() || 'Left joined register session',
                store_id: localStorage.getItem("store_id")
            });
            setLoading(false);
            if (result.success) {
                onHide(true);
                Utility.toastNotifications(result?.message, 'Success', 'success');
            } else {
                setFormError(result.message || t('order.businessRegister.closeFailed', 'Failed to leave register'));
            }
            return;
        }

        if (closingAmount === '' || parseFloat(closingAmount) < 0) {
            setFormError(t('order.businessRegister.enterValidAmount', 'Enter a valid amount'));
            return;
        }

        if (hasVariance && !closeNote.trim()) {
            setFormError(t('order.businessRegister.varianceNoteRequired', 'Counted cash differs from expected - a close note explaining the variance is required'));
            return;
        }

        setLoading(true);

        const payload = {
            closing_amount: parseFloat(closingAmount),
            expected_closing_amount: expectedAmount,
            credit_card_slips: parseInt(creditCardSlips),
            cheques: parseInt(cheques),
            confirm_variance: hasVariance,
            close_note: closeNote.trim(),
            store_id: localStorage.getItem("store_id")
        };
        console.log("the payload for close register",payload)

        const result = await closeBusinessRegister(payload);

        setLoading(false);

        if (result.success) {
            // print the receipt or next pop up   <=====
            onHide(true); // Pass true to indicate successful register closure
            // window.location.reload();
            Utility.toastNotifications(result?.message,'Success','success')
        } else {
            setFormError(result.message || t('order.businessRegister.closeFailed', 'Failed to close register'));
        }
    };

    return (
        <ModalGlobal
            show={show}
            onHide={() => onHide(false)}
            backdrop="static"
            keyboard={false}
            className="business-register-modal"
            headerclassName="close_btn_icon"
            bodyClassName="p-4"
            title={
                <span>
                    {mode === 'close'
                        ? t('order.businessRegister.closeTitle', 'Close Register')
                        : t('order.businessRegister.exitTitle', 'Exit Register')}
                </span>
            }
            closeButton={true}
            headerShow={true}
            footer={true}
            saveShow={true}
            cancelShow={true}
            onSave={handleSubmit}
            onCancel={() => onHide(false)}
            saveButtonLabel={t('continue', 'Continue')}
            cancelButtonLabel={t('common.buttons.cancel', 'Cancel')}
            saveButtonClassName="btn btn-primary"
            cancelButtonClassName="btn btn-white"
            saveButtonDisabled={loading}
            cancelButtonDisabled={loading}
            body={
                <div>
                    {formError && <Alert variant="danger">{formError}</Alert>}

                    {loading ? (
                        <div className="text-center p-4">
                            <Spinner animation="border" role="status" />
                        </div>
                    ) : (
                        <Form>
                            {mode === 'exit' ? (
                                <>
                                    <Alert variant="info" className="small">
                                        {t('order.businessRegister.leaveInfo', 'You joined this register. Leaving ends your session - the drawer is counted and reconciled by the register owner or a manager.')}
                                    </Alert>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('order.businessRegister.closeNote', 'Note')}</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            value={closeNote}
                                            onChange={(e) => setCloseNote(e.target.value)}
                                            placeholder={t('order.businessRegister.closeNotePlaceholder', 'Optional note')}
                                        />
                                    </Form.Group>
                                </>
                            ) : (
                                <>
                            <div className="d-flex justify-content-between mb-2 small">
                                <span className="text-muted">{t('order.businessRegister.expectedCash', 'Expected Cash')}</span>
                                <strong>{expectedAmount.toFixed(2)}</strong>
                            </div>
                            <div className={`d-flex justify-content-between mb-3 small ${hasVariance ? 'text-danger fw-bold' : 'text-success'}`}>
                                <span>{t('order.businessRegister.variance', 'Variance')}</span>
                                <strong>{variance > 0 ? '+' : ''}{variance.toFixed(2)}</strong>
                            </div>

                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {t('order.businessRegister.countedCash', 'Counted Cash')}
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    value={closingAmount}
                                    onChange={(e) => setClosingAmount(e.target.value)}
                                    min={0}
                                    step="0.01"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {t('order.businessRegister.totalCreditCardSlips', 'Total Credit Card Slips')}
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    value={creditCardSlips}
                                    onChange={(e) => setCreditCardSlips(e.target.value)}
                                    min={0}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {t('order.businessRegister.totalCheques', 'Total Cheques')}
                                </Form.Label>
                                <Form.Control
                                    type="number"
                                    value={cheques}
                                    onChange={(e) => setCheques(e.target.value)}
                                    min={0}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>
                                    {t('order.businessRegister.closeNote', 'Close Note')}
                                    {hasVariance && <span className="text-danger"> *</span>}
                                </Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    value={closeNote}
                                    onChange={(e) => setCloseNote(e.target.value)}
                                    placeholder={hasVariance
                                        ? t('order.businessRegister.varianceNotePlaceholder', 'Explain the cash variance')
                                        : t('order.businessRegister.closeNotePlaceholder', 'Optional note')}
                                />
                            </Form.Group>

                            {t('order.businessRegister.closeConfirmation', 'Are you sure you want to close register?')}
                                </>
                            )}

                            {mode === 'exit' && t('order.businessRegister.exitConfirmation', 'Are you sure you want to exit register?')}
                        </Form>
                    )}
                </div>
            }
        />
    );
};



export default CloseRegisterModal;
